import { render, staticRenderFns } from "./BulkUpdateDescription.vue?vue&type=template&id=659b9778&"
import script from "./BulkUpdateDescription.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports